import { FormikTagField as TagInput } from './TagInput';
export default TagInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/TagInput/index.tsx
// module id = 1483
// module chunks = 0